import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { AlertOperator } from '@/models/enums/AlertsEnums';
import { values } from '@/utils/enum';
import { uniqueId } from '@/utils/misc';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsOperatorsSelect',
  props: {
    value: null,
    disabled: { type: Boolean, default: false },
    validationRules: { default: () => ({}) }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: AlertOperator) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: AlertOperator, disabled: boolean, validationRules: ValidationRules };





const { t } = useI18n();

const componentId = uniqueId();

const state = reactive({
  operator: props.value,
});
const validations = {
  operator: props.validationRules,
};
const v$ = useVuelidate(validations, state);

function onInput(operator: AlertOperator) {
  state.operator = operator;
  emit('input', operator);
}

// It's necessary because the default value of operator is None, but not is not an allowed option.
// This also caused the placeholder to not be shown
const valueOrDefault = computed(() =>
  state.operator === AlertOperator.None ? undefined : state.operator,
);

const alertOperatorItems = values(AlertOperator).filter(
  (alertOperator) => alertOperator !== AlertOperator.None,
);

const required = computed(() => 'required' in props.validationRules);

const validationMessage = computed(
  () => v$.value.operator.$errors[0]?.$message,
);

return { __sfc: true,props, emit, t, componentId, state, validations, v$, onInput, valueOrDefault, alertOperatorItems, required, validationMessage, AlertOperator }
}

})